/**
 * Reviews carousel – Swiper initialisation
 */
(function () {
  function initReviewsCarousels() {
    document.querySelectorAll('[data-section-id]').forEach(function (sectionEl) {
      var swiperEl = sectionEl.querySelector('.reviews-carousel__swiper');
      if (!swiperEl || swiperEl.dataset.swiperInit === 'true') return;

      var sectionId = sectionEl.dataset.sectionId;
      var slidesPerView = parseInt(sectionEl.dataset.slidesPerView, 10) || 3;

      if (typeof Swiper === 'undefined') return;

      var slides = swiperEl.querySelectorAll('.swiper-slide');
      if (slides.length === 0) return;

      var config = {
        slidesPerView: 1.2,
        spaceBetween: 10,
        loop: slides.length > 1,
        grabCursor: false,
        centeredSlides: true,
        speed: 1000,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        },
        breakpoints: {
          640: {
            slidesPerView: Math.min(2, slides.length),
            spaceBetween: 24
          },
          1024: {
            slidesPerView: Math.min(slidesPerView, slides.length),
            spaceBetween: 24
          }
        },
      };

      /* eslint-disable no-new */
      new Swiper(swiperEl, config);
      swiperEl.dataset.swiperInit = 'true';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReviewsCarousels);
  } else {
    initReviewsCarousels();
  }

  // Re-init when Shopify theme editor loads new section
  document.addEventListener('shopify:section:load', function () {
    initReviewsCarousels();
  });
})();
